import { createSelector } from 'reselect';
import * as root from '../';

const getNavState = (state: root.State) => state.nav;

export const getNumOfForReviewAssets = createSelector(getNavState, nav => nav.numOfForReviewAssets);
export const getNumOfForReviewDivisionAssets = createSelector(getNavState, nav => nav.numOfForReviewDivisionAssets);
export const getNumOfOpenRequests = createSelector(getNavState, nav => nav.numOfOpenRequests);
export const getNumOfUnreconciledTransactions = createSelector(getNavState, nav => nav.numOfUnreconciledTransactions);
